import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import { Cookie } from '@styled-icons/boxicons-regular/Cookie';

//Actions
import { pesquisa } from '../actions/termos/modelos';

const CookiesSite = (props) => {

    const [termo, setTermo] = useState('');

    const load = async () => {        
        const result = await props.pesquisa({idpromotora: props.idpromotora, idtermostipos: 3, idevento: 1});
        if(result&&result[0]){
            setTermo(result[0]);
        }
    }

    useEffect(() => {
        load();
    },[]);
    
    return getCookieConsentValue()===undefined?
        <CookieConsent buttonText="Accept/Aceitar" cookieName="cidtechApp" containerClasses="p-5" style={{zIndex: '9999'}}>        
            <Cookie size="10em" /><Card.Body className="text-center" dangerouslySetInnerHTML={{__html: termo!==false?`${termo.portugues} ${termo.ingles}`:''}} />
        </CookieConsent>
        :null;
}

export default connect(null,{pesquisa})(CookiesSite);